import { InputRadio } from "../../../../../../components/v2";

import { BALANCES_STRINGS } from "../../constants/strings";

type ImportBaseSystemStepPropsT = {
  baseSystemName: string;
  value: "all" | "no-balances";
  onChange: (value: "all" | "no-balances") => void;
};

const ImportBaseSystemStep = ({
  baseSystemName,
  value,
  onChange,
}: ImportBaseSystemStepPropsT) => {
  return (
    <InputRadio
      label=""
      name="importOption"
      checkedValue={value}
      onChange={(e) => onChange(e.value)}
      radios={[
        {
          id: "import-base-system-all",
          label: BALANCES_STRINGS.IMPORT_BASE_SYSTEM_ALL_LABEL,
          value: "all",
          description: BALANCES_STRINGS.IMPORT_BASE_SYSTEM_ALL_DESCRIPTION.replace(
            "{systemName}",
            baseSystemName,
          ),
        },
        {
          id: "import-base-system-with-balances",
          label: BALANCES_STRINGS.IMPORT_BASE_SYSTEM_NO_BALANCES_LABEL,
          value: "no-balances",
          description: BALANCES_STRINGS.IMPORT_BASE_SYSTEM_NO_BALANCES_DESCRIPTION,
        },
      ]}
      inline={false}
      isRequired
    />
  );
};

export default ImportBaseSystemStep;
